<template>
  <path
    d="M6 4.00018V7.17018C6 7.70018 6.21 8.21018 6.59 8.59018L10 12.0002L6.58 15.4202C6.21 15.8002 6 16.3102 6 16.8402V20.0002C6 21.1002 6.9 22.0002 8 22.0002H16C17.1 22.0002 18 21.1002 18 20.0002V16.8402C18 16.3102 17.79 15.8002 17.42 15.4302L14 12.0002L17.41 8.60018C17.79 8.22018 18 7.71018 18 7.18018V4.00018C18 2.90018 17.1 2.00018 16 2.00018H8C6.9 2.00018 6 2.90018 6 4.00018Z"
  />
</template>
